import React, { useEffect } from "react";
import { format } from "timeago.js";
import Avatar from "shared/Avatar/Avatar";
import { CiFacebook, CiInstagram, CiYoutube } from "react-icons/ci";
import Breadcrumb from "./Breadcrumb";
import Bio from "components/Text/Bio";
import Subscriber from "components/LikeDislikeSubcribe/Subscriber";
import Royalty from "components/LikeDislikeSubcribe/Royalty";
import View from "components/LikeDislikeSubcribe/View";
import { FiCheck, FiShare2 } from "react-icons/fi";
import { BsPatchCheckFill } from "react-icons/bs";
import { PiWalletFill } from "react-icons/pi";
import { FaApple } from "react-icons/fa";
import { SiGooglepay } from "react-icons/si";
import { StarIcon } from "@heroicons/react/24/solid"; // Full star
import { StarIcon as StarOutline } from "@heroicons/react/24/outline"; // for empty stars

const OperatorCoverHeader = ({
  operator,
  isOnline,
  follows,
  joinRoyalNumber,
  id,
  user,
  updateSubcribe,
  updateRoyalty,
  handleMessageSubmit,
  CommentLists,
  onShareClick, // ✅ NEW PROP
}) => {
  const currentOperator = operator?.[0];

  console.log({ isOnline });

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.3 && rating % 1 <= 0.7;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex space-x-1 text-yellow-500">
        {[...Array(fullStars)].map((_, i) => (
          <StarIcon key={`full-${i}`} className="w-3 h-3" />
        ))}
        {hasHalfStar && (
          <div className="relative w-3 h-3">
            <StarIcon className="absolute w-3 h-3 text-yellow-500" />
            <div className="absolute top-0 right-0 w-1.5 h-3 bg-dry" />
          </div>
        )}
        {/* Optional: show empty stars */}
        {[...Array(emptyStars)].map((_, i) => (
          <StarOutline key={`empty-${i}`} className="w-3 h-3" />
        ))}
      </div>
    );
  };

  function getOpenStatus(openingHours) {
    const now = new Date();
    const dayName = now.toLocaleDateString("en-NZ", { weekday: "long" });
    const hoursToday = openingHours?.find((h) => h.day === dayName);

    if (!hoursToday || hoursToday.slots.length === 0) {
      return { label: "Closed today", isOpen: false };
    }

    const currentTime = now.getHours() + now.getMinutes() / 60;
    let nextOpening = null;

    for (let slot of hoursToday.slots) {
      const [openHour, openMinute] = parseTime(slot.open);
      const [closeHour, closeMinute] = parseTime(slot.close);
      const openTime = openHour + openMinute / 60;
      const closeTime = closeHour + closeMinute / 60;

      if (currentTime >= openTime && currentTime <= closeTime) {
        return { label: `Open until ${slot.close}`, isOpen: true };
      }

      if (currentTime < openTime && !nextOpening) {
        nextOpening = slot.open;
      }
    }

    if (nextOpening) {
      return {
        label: `Closed now, next open at ${nextOpening}`,
        isOpen: false,
      };
    }

    return { label: "Closed for today", isOpen: false };
  }

  function parseTime(timeStr) {
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    if (period.toLowerCase() === "pm" && hours !== 12) hours += 12;
    if (period.toLowerCase() === "am" && hours === 12) hours = 0;
    return [hours, minutes || 0];
  }

  return (
    <div className="relative w-full max-w-[1280px] mx-auto bg-dry shadow-md rounded-xl overflow-hidden">
      <div className="block sm:hidden">
        <Breadcrumb
          name={currentOperator?.name}
          country={currentOperator?.country}
          town={currentOperator?.town}
          profesional={currentOperator?.profesional}
        />
      </div>
      {/* Cover Photo */}
      <div className="relative w-full h-[220px] sm:h-[280px]">
        <div
          className="absolute inset-0 bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${
              currentOperator?.coverPhoto || "/hero/lokalai24-25.jpg"
            })`,
          }}
        />
      </div>

      {/* Main Content */}
      <div className="relative p-4 sm:p-6 bg-dark text-white">
        {/* Logo Overlap */}
        <div className="absolute -top-16 sm:top-16 left-4 sm:left-6 w-20 h-20 sm:w-24 sm:h-24 rounded-full border-2 border-redlight shadow-md  flex flex-col items-center justify-center">
          <img
            src={currentOperator?.photo}
            alt="logo"
            className="w-full h-full object-cover rounded-full"
          />
          {/* Online/Offline label */}
          <span className="absolute -bottom-8 text-xs font-semibold text-center w-full">
            {isOnline ? (
              <span className="text-green-400">
                🟢{" "}
                {"Online".split("").map((letter, i) => (
                  <span key={i} className="flash-letter">
                    {letter}
                  </span>
                ))}
              </span>
            ) : (
              <span className="text-red-400">🔴 Offline</span>
            )}
          </span>
        </div>

        {/* Info Block */}
        <div className="sm:ml-28 mt-4 sm:mt-0">
          <div className="hidden lg:block">
            <Breadcrumb
              name={currentOperator?.name}
              country={currentOperator?.country}
              town={currentOperator?.town}
              profesional={currentOperator?.profesional}
            />
          </div>

          <div className="flex flex-wrap items-center justify-between mt-2 gap-y-2">
            <div className="flex space-x-2 items-center">
              <h1 className="text-xl font-bold">{currentOperator?.name} </h1>
              {currentOperator?.additionalInfo?.verified && (
                <p className="inline-flex items-center gap-1 px-2 py-0 text-[10px] font-normal text-redlight rounded-full">
                  {" "}
                  <BsPatchCheckFill className="text-redlight text-sm" />
                  Verified
                </p>
              )}
            </div>

            <div className="flex gap-2">
              <button
                onClick={onShareClick}
                className="bg-redlight p-2 rounded-full shadow-md hover:text-black"
              >
                <FiShare2 />
              </button>
              {[CiFacebook, CiInstagram, CiYoutube].map((Icon, i) => (
                <button
                  key={i}
                  className="bg-redlight p-2 rounded-full shadow-md"
                >
                  <Icon />
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-center mt-1 text-text">
            <span className="text-yellow-500">
              {renderStars(currentOperator.rating)}
            </span>
            <a href="#reviews" className="ml-2 text-redlight hover:underline">
              ({currentOperator.reviewCount})
            </a>
          </div>
          {/* Address + Contact */}
          <div className="flex flex-wrap items-center text-xs text-textGray mt-1 gap-x-2">
            {(() => {
              const status = getOpenStatus(currentOperator?.openingHours);
              const isOpen = status.isOpen;

              return (
                <div
                  className={`flex items-center gap-2 text-xs ${
                    isOpen ? "text-green-500" : "text-red-500"
                  }`}
                >
                  {isOpen ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-red-500"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  )}
                  <span className="text-xs">{status.label}</span>
                </div>
              );
            })()}
            <span className="mx-1">·</span>
            <p>{currentOperator?.phone}</p>
            <span className="mx-1">·</span>
            <p>{currentOperator?.email}</p>
          </div>
          <div className="flex flex-wrap items-center text-xs text-textGray mt-1 gap-x-2">
            <span className="text-xs">{follows} Followers </span>
            <span className="mx-1">.</span>
            <span>{joinRoyalNumber} Royalty </span>
            <span className="mx-1">.</span>

            <View userTo={id} userFrom={user?._id} />
            <span className="mx-1">.</span>

            <p>{format(currentOperator?.createdAt)}</p>
          </div>

          {/* Open/Closed Status */}

          {/* Badges */}
          <div className="flex flex-wrap gap-2 mt-3">
            {currentOperator?.profesional?.map((p, i) => (
              <span
                key={i}
                className="bg-red-100 text-redlight flex items-center px-3 py-1 text-xs rounded-full"
              >
                {p}
              </span>
            ))}

            {currentOperator?.additionalInfo?.payByApp && (
              <span className="bg-green-100 text-green-500 text-xs px-3 py-1 rounded-full flex items-center gap-x-2">
                <FiCheck className="text-green-500" />
                Bookings confirmed instantly
              </span>
            )}

            {currentOperator?.additionalInfo?.instantConfirmation && (
              <span className="bg-blue-100 text-blue-700 text-xs px-2 rounded-full flex items-center">
                <span className="flex items-center gap-1">
                  <FaApple className="text-sm" />
                  <span className="text-xs">Pay</span>
                </span>
                <span className="mx-1">.</span>
                <span className="flex items-center gap-1">
                  <SiGooglepay className="text-3xl translate-y-[1px]" />
                </span>
              </span>
            )}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6 max-w-[600px]">
            {/* Subscriber */}
            <div className="h-12 w-full">
              <Subscriber
                userTo={id || ""}
                userFrom={user._id}
                refreshFunction={updateSubcribe}
                className="w-full h-full"
              />
            </div>

            {/* Royalty */}
            <div className="h-12 w-full">
              <Royalty
                userTo={id || ""}
                operatorname={user._id}
                refreshFunction={updateRoyalty}
                className="w-full h-full"
              />
            </div>

            {/* Message */}
            <div className="h-12 w-full">
              <button
                onClick={handleMessageSubmit}
                className="w-full h-full px-4 flex items-center justify-center space-x-2 rounded-full text-sm font-semibold shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 text-white bg-gradient-to-r from-red-500 to-pink-500"
              >
                <span>Message</span>
              </button>
            </div>

            {/* Comments */}
            <div className="h-12 w-full">
              <button
                onClick={() => {
                  const el = document.getElementById("comments-section");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="w-full h-full px-4 flex items-center justify-center space-x-2 rounded-full text-sm font-semibold shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 text-white bg-gradient-to-r from-red-500 to-pink-500"
              >
                <span>{CommentLists.length}</span>
                <span>Comments</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperatorCoverHeader;
